import { roundPlayerRatingScore } from "./format-player-rating-score";

export enum PlayerRatingStarColor {
	Red = "red",
	Orange = "orange",
	Blue = "blue",
	Green = "green",
	Gold = "gold",
}

const RED_MAX_SCORE = 5;
const ORANGE_MAX_SCORE = 6.6;
const BLUE_MAX_SCORE = 7.6;
const GREEN_MAX_SCORE = 9;

export function getPlayerRatingStarColor(score?: number | null): PlayerRatingStarColor | undefined {
	if (score == null || Number.isFinite(Number(score)) === false) {
		return undefined;
	}

	const roundedScore = roundPlayerRatingScore(Number(score));

	if(roundedScore <= RED_MAX_SCORE) {
		return PlayerRatingStarColor.Red;
	}

	if (roundedScore <= ORANGE_MAX_SCORE) {
		return PlayerRatingStarColor.Orange;
	}

	if (roundedScore <= BLUE_MAX_SCORE) {
		return PlayerRatingStarColor.Blue;
	}

	if (roundedScore <= GREEN_MAX_SCORE) {
		return PlayerRatingStarColor.Green;
	}

	return PlayerRatingStarColor.Gold;
}
